import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.json';
import thTranslations from './locales/th.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      th: {
        translation: thTranslations,
      },
    },
    fallbackLng: 'en',
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'lang',
      // Don't re-detect language automatically to prevent override
      checkWhitelist: false,
      convertDetectedLanguage: (lng) => {
        console.log("[i18n] convertDetectedLanguage - input:", lng);
        // Convert EN/TH format to en/th format
        if (lng === 'EN' || lng === 'en') {
          console.log("[i18n] convertDetectedLanguage - returning: en");
          return 'en';
        }
        if (lng === 'TH' || lng === 'th') {
          console.log("[i18n] convertDetectedLanguage - returning: th");
          return 'th';
        }
        console.log("[i18n] convertDetectedLanguage - returning original:", lng);
        return lng;
      },
    },
  })
  .then(() => {
    console.log("[i18n] Initialized - language:", i18n.language);
    console.log("[i18n] Initialized - localStorage lang:", localStorage.getItem("lang"));
  });

export default i18n;
